
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "55be9ed4-c4bb-4be2-a955-a52bac538c92"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/project/app.config.js"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
